import styled, { css } from "styled-components"

import SVGIcon from "components/presenters/common/SVGIcon"

export default function OrderItemHeader({ orderNo, orderDate, onClick, hideBorder }) {
  return (
    <Block hideBorder={hideBorder}>
      <HeaderText>{`주문번호 : ${orderNo} | 주문일자 : ${orderDate}`}</HeaderText>
      {onClick && (
        <OrderDetailBtn onClick={onClick}>
          주문 상세
          <ArrowIconBlock>
            <SVGIcon name="arrow" />
          </ArrowIconBlock>
        </OrderDetailBtn>
      )}
    </Block>
  )
}

const Block = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (21 / 375));
  padding-bottom: calc(100vw * (16 / 375));
  border-bottom: 1px solid #d9d9d9;

  ${({ hideBorder }) =>
    hideBorder &&
    css`
      border-bottom: none;
      margin-bottom: 0;
    `}
`

const HeaderText = styled.span`
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (14 / 375));
  color: #7f7f7f;
`

const OrderDetailBtn = styled.button`
  display: flex;
  align-items: center;
  font-size: calc(100vw * (14 / 375));
  font-weight: 600;
  line-height: calc(100vw * (16 / 375));
  color: #ff9b57;
`

const ArrowIconBlock = styled.div`
  width: calc(100vw * (6 / 375));
  height: calc(100vw * (10 / 375));
  margin-left: calc(100vw * (7 / 375));

  svg {
    color: #ff9b57;
  }
`
